const config = {
  apiKey: "AIzaSyB0S8j9gDaEMtBE2rhV-qFio8X-YXKCCCQ",
  authDomain: "blog-app-211e7.firebaseapp.com",
  projectId: "blog-app-211e7",
  storageBucket: "blog-app-211e7.appspot.com",
  messagingSenderId: "463100495595",
  appId: "1:463100495595:web:360cc940d011cd4dbfa0ae"
};

export default config;